import { Environment } from '../../config/environment';
import { TokenData, TokenInfo } from './TokenData';
import { Storage } from '@lightningjs/sdk';
import { Backend } from '../Backend';
import { ITokenResponse } from '../models/AndromeTV.types';

const SessionKey = 'atv-session';

export class TokenApi {
  /**
   * Authorizes the user with a username and password
   */
  static authorize(backend: Backend, username: string, password: string): Promise<TokenData> {
    const params = {
      client_id: Environment.Oauth.clientId,
      client_secret: Environment.Oauth.secret,
      grant_type: 'password',
      username,
      password,
      authorization: btoa(`${Environment.Oauth.clientId}:${Environment.Oauth.secret}`),
    };
    return TokenApi._request(backend, params).then(response => {
      return new TokenData(response);
    });
  }

  /**
   * Refresh a security token
   */
  static refresh(backend: Backend, token: string): Promise<TokenData> {
    const params = {
      client_id: Environment.Oauth.clientId,
      client_secret: Environment.Oauth.secret,
      grant_type: 'refresh_token',
      refresh_token: token,
      authorization: btoa(`${Environment.Oauth.clientId}:${Environment.Oauth.secret}`),
    };
    return TokenApi._request(backend, params).then(response => {
      return new TokenData(response);
    });
  }

  /**
   * Load token information from local storage
   */
  static load(): TokenData | undefined {
    const value = Storage.get(SessionKey);
    if (value) {
      const token = new TokenData();
      if (value.access) {
        token.access = new TokenInfo(value.access.token, value.access.expires);
      }
      if (value.refresh) {
        token.refresh = new TokenInfo(value.refresh.token, value.refresh.expires);
      }
      return token;
    }
    return undefined;
  }

  /**
   * Save tokens to local storage
   */
  static save(token: TokenData) {
    console.log(token);
    if (token && token.access && token.access.isValid()) {
      console.log('token saved', token);
      Storage.set(SessionKey, {
        access: token.access,
        refresh: token.refresh,
      });
    }
  }

  /**
   * removes the saved tokens from storage
   */
  static removeSaved() {
    Storage.remove(SessionKey);
  }

  /**
   * Performs a request token to the oath server
   */
  static _request(backend: Backend, params: { [p: string]: string | number | boolean }): Promise<ITokenResponse> {
    const url = backend.makeUrl('oauth/v1/auth/token');
    return backend.postForm(url, params).then(data => {
      return data as ITokenResponse;
    });
  }
}
